import { useState, useEffect, useCallback } from 'react'

export const useKeyPress = (targetKey: string): boolean => {
  const [isKeyPressed, setIsKeyPressed] = useState(false)

  const downHandler = useCallback(
    ({ key }: KeyboardEvent) => {
      if (key === targetKey) {
        setIsKeyPressed(true)
      }
    },
    [targetKey],
  )

  const upHandler = useCallback(
    ({ key }: KeyboardEvent) => {
      if (key === targetKey) {
        setIsKeyPressed(false)
      }
    },
    [targetKey],
  )

  useEffect(() => {
    // Set up event listeners
    window.addEventListener('keydown', downHandler)
    window.addEventListener('keyup', upHandler)

    // Clean up the event listeners when the component unmounts
    return () => {
      window.removeEventListener('keydown', downHandler)
      window.removeEventListener('keyup', upHandler)
    }
  }, [downHandler, upHandler])

  return isKeyPressed
}
